export const Role = {
  Admin: "Admin",
  AvailableRoles: [
    "Team",
    "Admin",
    "League",
    "CombineBallotUser",
    "DraftGreenRoomBallotUser",
    "Top 5 BallotVote User",
  ],
  Team: "Team",
  CombineBallotUser: "CombineBallotUser",
  DraftGreenRoomBallotUser: "DraftGreenRoomBallotUser",
  DraftGLeagueBallotVoteUser: "GLeagueBallotVoteUser",
  League: "League",
};
